fragment AccountBenefitsFragment on account_GlobalSet {
  id
  name
  benefitsBlocks {
    ... on oneliner_Entry {
      id
      description
      typeHandle
    }
  }
}
